import Route from '@ember/routing/route';
import { instrumentRoutePerformance } from '@sentry/ember';
import type StoreService from 'scaleflow/services/store';
import { service } from '@ember/service';

class ConnectorsRoute extends Route {
  @service declare store: StoreService;

  model() {
    return this.store.findAll('integration-setting', { reload: true });
  }
}

export default instrumentRoutePerformance(ConnectorsRoute);
